<template>
	<client-only>
		<BaseModal
			v-model="showSzmdModal"
			:showCloseButton="true"
			title=""
			class="flex justify-center items-center align-center text-center"
		>
			<h2 class="text-3xl font-medium mb-6 -mt-10">
				{{
					$i18n.locale === "ro"
						? $t("voting") + " " + $t("szmdTexts.szmdTitle")
						: $t("szmdTexts.szmdTitle") + " " + $t("voting")
				}}
			</h2>
			<div class="w-full flex flex-col md:flex-row">
				<!-- Első doboz -->
				<div class="flex-1 mr-0 md:mr-6 mb-6 md:mb-0">
					<h2 class="text-2xl font-medium mb-2">{{ $t("szmdTexts.companyRateCta") }}</h2>
					<BaseLink class="w-full mt-8 mb-3" href="/szmd/rating">
						<BaseButton type="primary-red" class="w-full">
							{{ $t("vote") }}
						</BaseButton>
					</BaseLink>
				</div>

				<!-- Vonal - függőleges desktop-on, vízszintes mobil-on -->
				<div v-if="showSzmdBox" class="h-px md:h-auto md:w-[1px] bg-dj-red w-1/2 mx-auto"></div>

				<!-- Második doboz -->
				<div v-if="showSzmdBox" class="flex-1 ml-0 md:ml-6 mt-6 md:mt-0">
					<h2 class="text-2xl font-medium mb-4">{{ $t("szmdTexts.szmdBoxVoteTitle") }}</h2>
					<BaseLink class="w-full mt-8 mb-3" href="/szmd/box-rating">
						<BaseButton type="primary-red" class="w-full">
							{{ $t("vote") }}
						</BaseButton>
					</BaseLink>
				</div>
			</div>
		</BaseModal>
	</client-only>
</template>

<script setup lang="ts">
import { ref, computed } from "vue";
import { useVModel } from "@vueuse/core";

const props = defineProps({
	modelValue: {
		type: Boolean,
		default: false,
	},
});

const emit = defineEmits(["update:modelValue"]);

const alreadyVoted = ref(false);

const showSzmdModal = useVModel(props, "modelValue", emit);

// Read feature flag from runtime config: NUXT_SZMD_SHOW_BOX
const runtimeConfig = useRuntimeConfig();
const showSzmdBox = computed(() => {
	return runtimeConfig.public.activeConfig.szmdConfig.showBox;
});
</script>
